import { render, staticRenderFns } from "./ChapterAdminView.vue?vue&type=template&id=21413a51&scoped=true&"
import script from "./ChapterAdminView.vue?vue&type=script&lang=js&"
export * from "./ChapterAdminView.vue?vue&type=script&lang=js&"
import style0 from "./ChapterAdminView.vue?vue&type=style&index=0&id=21413a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21413a51",
  null
  
)

export default component.exports